module.exports = __webpack_public_path__ + "static/media/warning.204ccedb.png";